
import LocaleReceiver from 'ant-design-vue/es/locale-provider/LocaleReceiver';
import Cropper from 'cropperjs';
import {
  ZoomInOutlined,
  ZoomOutOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  SyncOutlined,
  UploadOutlined,
  CheckOutlined
} from '@ant-design/icons-vue';

export default {
  name: 'EleCropper',
  components: {
    LocaleReceiver,
    ZoomInOutlined,
    ZoomOutOutlined,
    ArrowLeftOutlined,
    ArrowRightOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    RotateLeftOutlined,
    RotateRightOutlined,
    SwapOutlined,
    SyncOutlined,
    UploadOutlined,
    CheckOutlined
  },
  props: {
    // 图片地址
    src: String,
    // 裁剪比例
    aspectRatio: {
      type: Number,
      default: 1
    },
    // 裁剪组件模式
    viewMode: Number,
    dragMode: String,
    initialAspectRatio: Number,
    minContainerWidth: Number,
    minContainerHeight: Number,
    minCanvasWidth: Number,
    minCanvasHeight: Number,
    minCropBoxWidth: Number,
    minCropBoxHeight: Number,
    croppedWidth: Number,
    croppedHeight: Number,
    croppedMinWidth: Number,
    croppedMinHeight: Number,
    croppedMaxWidth: Number,
    croppedMaxHeight: Number,
    croppedFillColor: Number,
    imageSmoothingEnabled: Boolean,
    imageSmoothingQuality: String,
    // 是否返回blob数据
    toBlob: Boolean,
    // 允许上传的图片类型
    accept: {
      type: String,
      default: 'image/*'
    },
    // 操作按钮布局
    tools: {
      type: [Boolean, String],
      default: true
    },
    // 是否显示预览组件
    showPreview: {
      type: Boolean,
      default: true
    },
    // 完成按钮文字
    okText: String
  },
  emits: ['done'],
  data() {
    return {
      // cropper实例
      ins: null,
      // 图片base64数据
      imgSrc: '',
      // 当前图片类型
      imgType: 'image/jpeg',
      // 预览组件宽度
      previewWidth: 120
    };
  },
  computed: {
    // 预览组件样式
    pStyle() {
      return `width: ${this.previewWidth + 20}px;text-align: right;font-size: 0;`;
    },
    pItemStyle1() {
      const h = this.previewWidth / (this.aspectRatio || 1);
      return `width: ${this.previewWidth}px;height: ${h}px;`;
    },
    pItemStyle2() {
      return this.pItemStyle1 + 'border-radius: 50%;margin-top: 10px;';
    },
    pItemStyle3() {
      const w = this.previewWidth / 3 * 2 - 10, h = w / (this.aspectRatio || 1);
      return `width: ${this.previewWidth}px;height: ${h}px;margin-top: 10px;`;
    },
    pItemStyle4() {
      const w = this.previewWidth / 3, h = w / (this.aspectRatio || 1);
      return `width: ${this.previewWidth}px;height: ${h}px;margin: 10px 0 0 10px;`;
    },
    // 解析按钮布局
    toolGroup() {
      if (typeof this.tools === 'string') {
        let tool = [];
        this.tools.split('|').forEach(g => {
          tool.push(g.split(',').map(b => b.trim()));
        });
        return tool;
      } else if (this.tools) {
        return [
          ['zoomIn', 'zoomOut'],
          ['moveL', 'moveR', 'moveT', 'moveB'],
          ['rotateL', 'rotateR'],
          ['scaleX', 'scaleY'],
          ['reset', 'upload'],
          ['crop']
        ];
      }
      return [];
    }
  },
  mounted() {
    // ie兼容
    if (this.src && this.src.indexOf('data:image') !== 0 && (!!window.ActiveXObject || 'ActiveXObject' in window)) {
      let req = new window.XMLHttpRequest();
      req.open('GET', this.src, true);
      req.responseType = 'arraybuffer';
      req.onload = () => {
        if ([200, 201].indexOf(req.status) === -1) {
          console.error('cropper', req);
          return;
        }
        let bytes = new Uint8Array(req.response), binary = '';
        for (let i = 0; i < bytes.byteLength; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        this.imgSrc = 'data:image/jpeg;base64,' + window.btoa(binary);
        this.$nextTick(() => {
          this.render();
        });
      };
      req.send();
    } else if (this.src) {
      this.imgSrc = this.src;
      this.$nextTick(() => {
        this.render();
      });
    } else {
      this.render();
    }
  },
  methods: {
    /* 渲染 */
    render() {
      if (this.ins) {
        this.ins.destroy();
      }
      let options = {
        aspectRatio: this.aspectRatio,
        viewMode: this.viewMode,
        dragMode: this.dragMode,
        initialAspectRatio: this.initialAspectRatio,
        minContainerWidth: this.minContainerWidth,
        minContainerHeight: this.minContainerHeight,
        minCanvasWidth: this.minCanvasWidth,
        minCanvasHeight: this.minCanvasHeight,
        minCropBoxWidth: this.minCropBoxWidth,
        minCropBoxHeight: this.minCropBoxHeight
      };
      if (this.showPreview) {
        options.preview = this.$refs.eleCropperPreviews.children;
      }
      this.ins = new Cropper(this.$refs.eleCropperImg, options);
    },
    /* 操作按钮点击事件 */
    onAction(e) {
      let method = this.getDataset(e.currentTarget, 'method'),
        option = this.getDataset(e.currentTarget, 'option'),
        secondOption = this.getDataset(e.currentTarget, 'option2');
      if (!this.ins || !method) {
        return;
      }
      let cropped = this.ins.cropped, result;
      switch (method) {
        case 'rotate':
          if (cropped && this.viewMode > 0) {
            this.in.clear();
          }
          break;
        case 'getCroppedCanvas':
          option = JSON.parse(option || '{}') || {};
          if (this.imgType === 'image/jpeg') {
            option.fillColor = '#fff';
          }
          option.width = this.croppedWidth;
          option.height = this.croppedHeight;
          option.minWidth = this.croppedMinWidth;
          option.minHeight = this.croppedMinHeight;
          option.maxWidth = this.croppedMaxWidth;
          option.maxHeight = this.croppedMaxHeight;
          option.fillColor = this.croppedFillColor;
          option.imageSmoothingEnabled = this.imageSmoothingEnabled;
          option.imageSmoothingQuality = this.imageSmoothingQuality;
          break;
      }
      result = this.ins[method](option, secondOption);
      switch (method) {
        case 'rotate':
          if (cropped && this.viewMode > 0) {
            this.ins.crop();
          }
          break;
        case 'scaleX':
        case 'scaleY':
          this.setDataset(e.currentTarget, 'option', -option);
          break;
        case 'getCroppedCanvas':
          if (result) {
            if (this.toBlob) {
              result.toBlob((blob) => {
                this.$emit('done', blob);
              }, this.imgType);
            } else {
              this.$emit('done', result.toDataURL(this.imgType));
            }
          } else {
            this.$message.error('裁剪失败');
          }
          break;
      }
    },
    /* 图片上传处理 */
    onUpload(file) {
      this.imgType = file.type;
      let reader = new FileReader();
      reader.onload = (e) => {
        this.ins.replace(e.target.result);
      };
      reader.readAsDataURL(file);
      return false;
    },
    /* 获取dataset属性 */
    getDataset(elem, key) {
      if (elem.dataset) {
        return elem.dataset[key];
      } else {
        return elem.getAttribute('data-' + key);
      }
    },
    /* 设置dataset属性 */
    setDataset(elem, key, value) {
      if (elem.dataset) {
        elem.dataset[key] = value;
      } else {
        elem.setAttribute('data-' + key, value);
      }
    }
  }
}
